import { mutate } from 'swr';
import axios from 'axios';
import { getError } from '@shared/utils/helpers';
import { Notistack } from '../../../../../../shared/components/Notistack/Notistack';
import { TFormula } from '../../interfaces';

export const requestCreateFormula = (lenderId: string, formula: TFormula) => {
  const path = `/lender-service/lenders/${lenderId}/formula`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.put(path, formula);
      Notistack.successMessage('Formula - Created Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestUpdateFormula = (lenderId: string, formula: TFormula) => {
  const path = `/lender-service/lenders/${lenderId}/formula`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.patch(path, formula);
      Notistack.successMessage('Formula - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteFormula = (lenderId: string, formulaId = '') => {
  const path = `/lender-service/lenders/${lenderId}/formula/${formulaId}`;
  return mutate(`/lender-service/lenders/${lenderId}`, async() => {
    try {
      await axios.delete(path);
      Notistack.successMessage('Formula - Deleted Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
